var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-5"},[_vm._v("Form Şablon Listesi")]),_c('v-card',[_c('v-tabs',[_c('v-tab',[_vm._v("Hazır Şablonlar")]),_c('v-tab-item',{attrs:{"transition":"fade-transition","reverse-transition":"fade-transition"}},[_c('FormTemplateList')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }